export default __webpack_public_path__ + "static/media/digital-label-icon.7dc1a019.svg";